import coastbanner from "../assets/coast.png"

function Banner() {
    return(
<div id="coast-banner">
    <img src ={coastbanner}
         alt="image of a coast spot with the sea"/>
    <p>At home, everywhere, and anywhere</p>
</div>
    );
}

export default Banner